import React from "react";

const GuestFoot = () => {

  return (
<footer className="footer">
  <div className="content has-text-centered">
  <a href="https://www.federrafting.it/" target="_blank" rel="noreferrer" className="footLogo">
          <img className="headLogo" src="/img/firaft-logo.png" alt="FIRAFT" />
        </a>
    <p>
      <strong>FIRAFT Bookings</strong> by <a href="https://www.beinternet.it/" target="_blank" rel="noreferrer">Be Internet</a>.
      <span className="is-size-7 mx-2 has-text-grey-lighter">CS03</span>
    </p>
  </div>
</footer>
  );
};

export default GuestFoot;
